import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { FuelType } from "__generated__/enums";
import { intl } from "LocaleWrapper";

const ShipFuelTypeSelect = <Multiple extends boolean = false,>({
	...rest
}: Omit<SelectProps<FuelType, Multiple>, "disableSearch" | "fetchOptions" | "paginated" | "getOptionLabel">) => {
	return (
		<Select
			disableSearch
			fetchOptions={Object.values(FuelType)}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			{...rest} />
	);
};

export default ShipFuelTypeSelect;
